import { render } from "./GalaxyMain.vue?vue&type=template&id=47719e21&scoped=true&ts=true"
import script from "./GalaxyMain.vue?vue&type=script&lang=ts"
export * from "./GalaxyMain.vue?vue&type=script&lang=ts"

import "./GalaxyMain.vue?vue&type=style&index=0&id=47719e21&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47719e21"]])

export default __exports__